<template>
  <div>
      <b-container fluid style="padding-top: 100px;">
        <b-row>
          <b-col cols="12 headerF"><HeaderFixed/></b-col>
          <b-col cols="12 headerM"><HeaderMobile/></b-col>
        </b-row>
      <b-row>
          <b-col cols="12">
            <b-breadcrumb style="background-color: #e9ecef78;">

                <b-breadcrumb-item href="#home">
                  <router-link to="/">
                  <b-icon icon="house-door" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                    Home
                    </router-link>
                </b-breadcrumb-item>

               <b-breadcrumb-item href="#" active>Gallery</b-breadcrumb-item>
            </b-breadcrumb>
          </b-col>
          <b-col cols="12">
            <span class="title">Gallery</span>
          </b-col>
      </b-row>

    <b-row>
        <b-col cols="12">
          <div id="gal">
              <b-row >
                <b-col cols="12" class="text-center">
                  <div class="p-4 border rounded bg-light">
                    <h5 class="mb-2">Gallery is being updated</h5>
                    <p class="text-muted">Photos will be uploaded shortly.</p>
                  </div>
                </b-col>
                <!-- <b-col cols="6" sm="3" md="3" ld="3">
                  <router-link to="/APDCLGuestHouse">
                  <section>
            					<figure class="stack stack-spread active">

    					        <img :src="images1.thumbnail" alt="img03"/>
            					<img :src="images1.thumbnail" alt="img02"/>
            					<img :src="images1.thumbnail" alt="img01"/>
                  	</figure>
                      <span align="center">{{ images1.caption }}</span>
            			</section>
                  </router-link>
                </b-col> -->

                <!-- <b-col cols="6" sm="3" md="3" ld="3" >
                  <router-link to="/70independenceday">
                  <section>
            					<figure class="stack stack-spread active">

    					        <img :src="images2.thumbnail" alt="img03"/>
            					<img :src="images2.thumbnail" alt="img02"/>
            					<img :src="images2.thumbnail" alt="img01"/>
                  	</figure>
                      <span align="center">{{ images2.caption }}</span>
            			</section>
                  </router-link>
                </b-col> -->

                <!-- <b-col cols="6" sm="3" md="3" ld="3" >
                  <router-link to="/badminton2016">
                  <section>
            					<figure class="stack stack-spread active">

    					        <img :src="images3.thumbnail" alt="img03"/>
            					<img :src="images3.thumbnail" alt="img02"/>
            					<img :src="images3.thumbnail" alt="img01"/>
                  	</figure>
                      <span align="center">{{ images3.caption }}</span>
            			</section>
                  </router-link>
                </b-col> -->
            </b-row>
          </div>
      </b-col>
    </b-row>
    </b-container>
  </div>
</template>

		<style>
    .headerF{
      display: block;
    }
    .headerM{
      display: none;
    }
		.stack {
	margin: 30px auto;
	width: 60%;
  height:100px;
	padding: 0;
	position: relative;
	max-width: 100%;
  cursor: pointer;
  transition: all 0.5s ease;
}
.stack:hover
{
  /* transform: rotate(20deg); */
  transform: scale(1.12) ;
}

.stack img {
  height:100px;
	width: 100%;
  border-radius: 5px;
	position: absolute;
	top: 0;
	left: 0;
	-webkit-transition: all 0.3s;
	transition: all 0.3s;
	outline: 1px solid transparent;
}

.stack img:last-child {
	position: relative;
}


.stack-spread.active img:nth-child(3) {
	-webkit-transform: translate(-10px,10px);
	transform: translate(-10px,10px);
}

.stack-spread.active img:first-child {
	-webkit-transform: translate(10px,-10px);
	transform: translate(10px,-10px);
}
@media (max-width: 768px) {
    .headerF{
      display: none;
    }
    .headerM{
      display: block;
    }
  }

		</style>

<script>
import HeaderFixed from '@/components/HeaderFixed.vue'
import HeaderMobile from '@/components/HeaderMobile.vue'
export default({
  components: {
    'HeaderFixed' : HeaderFixed,
    'HeaderMobile' : HeaderMobile
    },

  data() {
    return {
      images1: {

          src: require("../assets/gallery/APDCLGuestHouse/Gallery_3_01.jpeg"),
          alt: "Alt 1",
          thumbnail: require("../assets/gallery/APDCLGuestHouse/Gallery_3_01.jpeg"),
          caption: "APDCL Guest House, ASEB Colony, Narengi, Guwahati - 26"

        },
        images2: {

            src: require("../assets/gallery/70thIndependenceDaycelebrationinAPDCL/Gallery_1_01.jpeg"),
            alt: "Alt 1",
            thumbnail: require("../assets/gallery/70thIndependenceDaycelebrationinAPDCL/Gallery_1_01.jpeg"),
            caption: "70th Independence Day celebration in APDCL"

          },
          images3: {

              src: require("../assets/gallery/41stAIESCBBadmintonTournament2016/Gallery_2_01.jpeg"),
              alt: "Alt 1",
              thumbnail: require("../assets/gallery/41stAIESCBBadmintonTournament2016/Gallery_2_01.jpeg"),
              caption: "41st AIESCB Badminton Tournament 2016"

            },
      index: null
    }
  }
});
</script>
